// generated by the plop

import { CompletedWorkTransactionModel, SummaryCompletedWorkModel } from 'shared';
import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';

export interface CompletedWorkStateModel {
  currentTransactions: PaginatorModel<CompletedWorkTransactionModel>;
  loadTransactionsStatus: PROGRESS_STATUSES;
  summaryCompletedWork: SummaryCompletedWorkModel;
  summaryCompletedWorkGroupedByUserId: SummaryCompletedWorkModel[];
  loadSummaryStatus: PROGRESS_STATUSES;
}

export const COMPLETED_WORK_STATE_DEFAULT: CompletedWorkStateModel = {
  currentTransactions: {
    data: [],
    meta: null,
    links: null
  },
  loadTransactionsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  loadSummaryStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  summaryCompletedWork: null,
  summaryCompletedWorkGroupedByUserId: []
};
